import React from 'react';
import { useNavigate } from 'react-router-dom';

import { AdnetoLogo } from '../../assets/images';

import { DOCS } from '../../Routes/RouterConstant';

const Header = () => {
  const navigate = useNavigate();
  return (
    <div className='w-full mx-auto justify-between gap-2.5 px-5 md:px-10 pt-1 z-50 top-0 fixed flex md:flex-row flex-col md:items-center shadow-none backdrop-blur-[6px] bg-[#fafafa00] text-[#333333]'>
      <img src={AdnetoLogo} alt="Adneto logo" className='cursor-pointer' loading='lazy' width={200} onClick={() => navigate(DOCS)} />
      <div className='md:text-base lg:text-2xl text-sm' >ADNETO Integration Documentation - Reward Management Platform (1.0.0)</div>
    </div>
  )
}

export default Header
